import { IpadPrintsModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<IpadPrintsModel>('/ipad/ipad-prints');
export default api;
